import React, { memo } from 'react';
import styled from 'styled-components';

interface HourCardListDayProps {
    weekday: string;
}

export const HourCardListDay = memo(({ weekday = '' }: HourCardListDayProps) => {
    return (
        <Container>
            {weekday}
        </Container>
    );
});

const Container = styled.li`
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 20px;
    margin-bottom: 5px;
    font-size: 16px;
    font-weight: 400;
    color: white;
`;